import {API} from '../../Services';

async function StoreOnlineData(merchantId){
    let mallId= localStorage.getItem('mallId');
    let token =  localStorage.getItem('token');
    return API.get(`/shop/${merchantId}/page-public`
        );
}

async function DeleteBasket(){
    let token =  localStorage.getItem('token');
    return API.post(`/shop/cart/empty/`,{},{headers: { 'Authorization':  `Bearer ${token}`}});
}



export {StoreOnlineData,DeleteBasket}
